<template>
    <div>
        <h2>UI elements</h2>
        <div class="ui">
            <div>
                <ABadge>Badge..</ABadge>
                <ABadge alt>Badge alt..</ABadge>
            </div>
            <div><ABtn label="Button" bg="#ddf" shadow color="#111"></ABtn>
            </div>
            <div>
                <ACheckbox label="Checkbox"/>
            </div>
            <div>
                <AChip>chip</AChip>
            </div>
            <div>
                <ADatePicker label="datePicker" name="dp" placeholder="datepicker placehilder"/>
            </div>
            <div>
                <AField placeholder="field.." label="field label"/>
            </div>

            <div>
                <AInput placeholder="AInput.." label="AInput label"/>
                <AInput static-label type="password" placeholder="password" label="AInput label">
                    <template #error="val">{{val}}</template>
                </AInput>
                <AInput static-label placeholder="AInput.." label="AInput label (static label)"/>
            </div>

            <div>
                is checked {{fields.checked}}
                <ARadioButtonGroup :options="[{value: 'option1', label: 'Option 1'}, {value: 'option2', label: 'Option 2', checked: true}]" name="test" v-model="fields.checked"/>
<!--                <ARadioBtn label="check me 1" v-model="fields.checked"/>-->
<!--                <ARadioBtn label="check me 2" v-model="fields.checked"/>-->
            </div>

            <div>
                <UseAProgressBar/>
            </div>
            <div>
                <code>
                    @prop <b>static-label</b> - фиксированный label вверху <br>
                    @prop <b>display</b> - свойство из обьекта options для отображения в качестве текста в опциях <br>
                    @prop <b>options</b> - обьект с опциями <br><br>


                    template <b>#item</b> - шаблон для отображения опции. <br>
                </code>
                <ASelect static-label
                         label="Категория проекта"
                         display="title"
                         placeholder="Выберите категорию"
                         :options="[{value: 'option1code', title: 'Option 1 name'}, {value: 'option2code', title: 'Option 2 name'}]"
                         v-model="selected"
                >
                    <template #item="{title}">{{ title }}</template>
                </ASelect>
                <ASelect static-label
                         label="Категория проекта (multiple)"
                         display="title"
                         placeholder="Выберите категорию"
                         :options="[{value: 'option1code', title: 'Option 1 name'}, {value: 'option2code', title: 'Option 2 name'}]"
                         v-model="selected"
                         multiple
                >
                    <template #item="{title}">{{ title }}</template>
                </ASelect>
            </div>
        </div>


        <h2>Cards</h2>
        <div class="cards">
            <ArticleCard title="Article card example" text="Article card text" col="1" date="1.1.1970"
                         image="/local/templates/main/img/content/article-1.jpg" read-time="01.01.1970" url="/"/>

            <ClientCard col="1" text="ClientCard" title="Client card title" link="/" desc="description"/>

            <DirectionCard title="DirectionCard" text="DirectionCard text" col="1" url="/"
                           image="/local/templates/main/img/content/article-2.jpg"/>

            <div style="background: #2F3941">
                <HelpCard text="HelpCard text" title="HelpCard title" action="action.."
                          bg="/local/templates/main/img/content/article-3.jpg" btn="Btn label"
                          icon="/local/templates/main/img/icons/facebook.svg"/>
            </div>

            <NumbersCard text="NumbersCard" number="1"/>

            <PartnerCard title="PartnerCard" image="/local/templates/main/img/content/users/user-1.jpg" col="1"/>

            <ProjectCard title="ProjectCard" rating_max="5" rating_min="1" deadline="1.1.1970" responds="responds.."
                         :tags="['tag1', 'tag2']" :volunteers="['vol1', 'vol2']"/>

            <TaskCard :volunteers="['v1', 'v2']" :responds="['r1', 'r2']" rating_min="1" rating_max="5"
                      title="TaskCard title" image="/local/templates/main/img/content/article-3.jpg" url="/"
                      deadline="1.1.1970" category="c.."/>

            <TaskCategoryCard url="/" title="TaskCategoryCard" col="1"
                              image="/local/templates/main/img/content/article-1.jpg" :tasks="'tasks..'"/>

            <VolonterCard col="1" url="/" photo="/local/templates/main/img/content/users/user-2.jpg"
                          name="VolonterCard name" projects="projects.." rang="1" rating="100" spec="spec.."/>

        </div>
    </div>
</template>

<script>
import {ref} from 'vue';
import {
    AStepper,
    AStep,
    ABadge,
    AField,
    AInput,
    ACheckbox,
    ABtn,
    ASelect,
    AChip,
    ADatePicker,
    useAProgressBar
} from '../components/ui'

import ArticleCard from "../components/cards/ArticleCard";
import ClientCard from "../components/cards/ClientCard";
import DirectionCard from "../components/cards/DirectionCard";
import HelpCard from "../components/cards/HelpCard";
import NumbersCard from "../components/Numbers/NumbersCard";
import PartnerCard from "../components/cards/PartnerCard";
import ProjectCard from "../components/cards/ProjectCard";
import TaskCard from "../components/cards/TaskCard";
import TaskCategoryCard from "../components/cards/TaskCategoryCard";
import VolonterCard from "../components/cards/VolonterCard";
import ARadioBtn from "../components/ui/ARadioBtn";
import ARadioButtonGroup from "../components/ui/ARadioButtonGroup";

export default {
    name: "UiPage",
    components: {
        ARadioButtonGroup,
        ARadioBtn,
        VolonterCard,
        TaskCategoryCard,
        TaskCard,
        ProjectCard,
        PartnerCard,
        NumbersCard,
        HelpCard,
        DirectionCard,
        ClientCard,
        ArticleCard,
        AStepper,
        AStep,
        ABadge,
        AField,
        AInput,
        ACheckbox,
        ABtn,
        ASelect,
        AChip,
        ADatePicker,
        useAProgressBar
    },
    setup() {
        const selected = ref('') // option1code
        const fields = ref({})

        return {
            selected,
            fields
        }
    }
}
</script>

<style scoped>
.cards {
    display: grid;
    grid-template-columns: repeat(3, 1fr);
    gap: 10px;
}

.ui {
    display: grid;
    grid-template-columns: repeat(4, 1fr);
    gap: 10px;
}
</style>